import http from '../_helpers/http.service';

export const notificacionService = {
    getNotificacionesPU,
    marcarLeidas,
    bootstrap
};

function getNotificacionesPU() {
    var url = '/api/notificaciones/traerPU';
    return http.get(url);
}

function marcarLeidas() {
    var url = '/api/notificaciones/marcarLeidas';
    return http.get(url);
}

function bootstrap() {
    const subdomain = getSubdomain();
    return http.post('/init', {subdomain: subdomain});
}

function getSubdomain() {
    const hostname = window.location.hostname;

    // Si es localhost o IP, retornar null o un valor por defecto
    if (hostname === 'localhost' || hostname.match(/^\d+\.\d+\.\d+\.\d+$/)) {
        return null; // o return 'localhost';
    }

    // Dividir por puntos y obtener el primer elemento
    const parts = hostname.split('.');

    // Para dominios como "app.iotech.cloud", parts sería ["app", "iotech", "cloud"]
    // Quitamos el TLD (últimas 2 partes) y nos quedamos con el subdominio
    if (parts.length > 2) {
        return parts[0]; // Retorna "app"
    }

    return null; // No hay subdominio
}

